
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telus/about/news-and-events/media-releases/[...slug]",
      function () {
        return require("private-next-pages/telus/about/news-and-events/media-releases/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telus/about/news-and-events/media-releases/[...slug]"])
      });
    }
  